"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackExposure = exports.create = void 0;

var _usageTrackerContainer = require("usage-tracker-container");

var create = function create(version) {
  var tracker = null;

  try {
    tracker = (0, _usageTrackerContainer.getPrimaryTracker)().clone({
      events: {
        experimentExposure: {
          name: 'product experiment exposure',
          class: 'exposure',
          version: version,
          properties: {
            experimentName: 'string',
            experimentParams: 'string'
          }
        }
      },
      properties: {
        namespace: 'hublabs'
      }
    });
  } catch (err) {
    /* NOOP */
  }

  return tracker;
};

exports.create = create;

var trackExposure = function trackExposure(track, eventProperties) {
  track('experimentExposure', eventProperties);
};

exports.trackExposure = trackExposure;